import React from 'react'

// import { Container } from './styles';

function Countdown(props) {
  const { startDate, endDate, hideOnEnd } = props

  const [timeLeft, setTimeLeft] = React.useState(endDate - startDate)
  const [currentTime, setCurrentTime] = React.useState(
    new Date(timeLeft).toISOString().slice(11, 19)
  )
  React.useEffect(() => {
    if (!timeLeft) return
    const intervalId = setTimeout(() => {
      const timeDiff = timeLeft - 1
      console.log(timeLeft, currentTime)
      setTimeLeft(timeDiff)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [timeLeft, currentTime])

  React.useEffect(async () => {
    const formatTime = await new Date(timeLeft).toISOString().slice(11, 19)
    console.log(timeLeft, formatTime)
    setCurrentTime(formatTime)
  }, [timeLeft])

  return (
    <div
      className="mdn-Countdown mdn-Countdown--sm"
      data-mdn-start-date={startDate}
      data-mdn-end-date={endDate}
      data-mdn-hide-on-end={hideOnEnd}
    >
      <div className="mdn-Countdown-content-title">SM - Acaba em: </div>
      <div className="mdn-Countdown-timer">
        {currentTime} || {timeLeft}{' '}
      </div>
    </div>
  )
}

export default Countdown
